import axios from 'axios';
import { apiUrl } from '../constant';

const getInvoiceGroupHeaderService = data => {
    return axios.post(`${apiUrl}/api/Ledger/GetInvoiceGroupHeader`, data);
};

/**
 * Fetches invoice service charges and details from API
 * @param {number} invoiceId - The invoice ID
 * @param {Array} sellerIdList - List of seller IDs
 * @param {Array} companyIdList - List of company IDs
 * @returns {Promise} Axios promise with invoice lookup data
 */
const getInvoiceLookup = (invoiceId, sellerIdList, companyIdList) => {
    return axios.post(`${apiUrl}/api/Ledger/GetInvoiceLookup`, {
        pageSize: 100,
        pageIndex: 0,
        invoiceId,
        sellerIdList,
        companyIdList,
    });
};

export const Invoice = {
    getInvoiceGroupHeaderService,
    getInvoiceLookup,
};
